import makeStyles from "@mui/styles/makeStyles";

import prevIcon from "assets/images/leftCaretIcon.svg";
import nextIcon from "assets/images/rightCaretIcon.svg";

export default makeStyles(
  (theme) => ({
    root: {
      marginBottom: 28,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 29,
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 40,
      },
    },
    slide: {
      margin: [0, 0, 0, 0],
      height: "auto",
      width: "100%",
      minHeight: 1,
      position: "relative",
    },

    "@global": {
      ":root": {
        "--swiper-navigation-size": "30px",
      },
      ".swiper-container": {
        marginRight: "-16px !important",
        [theme.breakpoints.up("mobile")]: {
          marginRight: "auto !important",
        },
      },
      ".swiper-wrapper": {
        height: "auto",
      },
      ".swiper-button-prev::after, .swiper-button-next::after": {
        height: 60,
        width: 60,
        opacity: 0.5,
        fontSize: "0 !important",
        boxShadow: "0 2px 3px 0 rgba(37,45,95,.25)",
        position: "absolute",
        background: "white",
        borderRadius: 40,
        zIndex: 10,
        cursor: "pointer",
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        flexWrap: "nowrap",
        color: "rgba(0,0,0,.25)",
      },
      ".swiper-button-prev::after": {
        content: `url(${prevIcon}) !important`,
        paddingLeft: 7,
      },
      ".swiper-button-next::after": {
        content: `url(${nextIcon}) !important`,
        paddingLeft: 12,
      },
      ".swiper-button-prev, .swiper-button-next": {
        display: "none !important",
        verticalAlign: "top",
        [theme.breakpoints.up("mobile")]: {
          display: "flex !important",
        },
      },
      ".swiper-button-prev:hover::after, .swiper-button-next:hover::after": {
        "@media (hover: hover)": {
          opacity: 0.8,
        },
      },
      ".swiper-button-next": {
        marginRight: 20,
      },
      ".swiper-button-prev": {
        marginLeft: 20,
      },
      ".swiper-slide": {
        display: "flex",
        justifyContent: "center",
        position: "relative",
        height: "auto",
        [theme.breakpoints.up("mobile")]: {
          justifyContent: "stretch",
        },
      },
    },
  }),
  { name: "StarringYouClipsCarousel" },
);
